import { BasicInformationPage } from './BasicInformationPage';
import { ConfirmJobDetailsPage } from './ConfirmJobDetailsPage';
import { JobDescriptionPage } from './JobDescriptionPage';
import { ReviewAndPaymentPage } from './ReviewAndPaymentPage';
import { WorkDetailsPage } from './WorkDetailsPage';

export * from './CreatePermanentJobsPage';
export * from './ConfirmJobDetailsPage';
export * from './Types';

export const CreatePermanentJobPosting = {
  BasicInformationPage,
  ConfirmJobDetailsPage,
  JobDescriptionPage,
  ReviewAndPaymentPage,
  WorkDetailsPage,
};
